import { saveAs } from 'file-saver'
import Feature from 'ol/Feature';
import { transform as olTransform } from 'ol/proj';
import { SimpleGeometry } from 'ol/geom';

export const geoJsonExport = {
    // Returns GeoJSON string of given features
    getGeoJSON: function(features: Feature[]): string {
        const coordsNE: Coordinate[][][] = features.map(f => (f.getGeometry() as SimpleGeometry).getCoordinates());
        const drawings = coordsNE.map(coord => {
            return coord.map(outline => {
                return outline.map(point => olTransform(point, 'EPSG:3857', 'EPSG:4326'));
            });
        });
        const geoJsonFeatures = drawings.map((drawing, index) => {
            return {
                type: "Feature",
                properties: {
                    id: index,
                    name: `Drawing ${index + 1}`
                },
                geometry: {
                    type: "Polygon",
                    coordinates: drawing
                }
            };
        });
        const geoJson = {
            type: "FeatureCollection",
            features: geoJsonFeatures
        };
        return JSON.stringify(geoJson, null, 2);
    },
    // Returns GeoJSON as a Blob
    getFile: function(features: Feature[]): Blob {
        const geoJSON = this.getGeoJSON(features);
        return new Blob([geoJSON], { type: 'text/json;charset=utf-8' });
    },
    // Returns GeoJSON as an ArrayBuffer
    getArrayBuffer: async function(features: Feature[]): Promise<ArrayBuffer> {
        const geoJSON: Blob = await this.getFile(features);
        return geoJSON.arrayBuffer();
    },
    // Saves GeoJSON to a file
    export: function(features: Feature[]): void {
        const file = this.getFile(features);
        saveAs(file, 'infrakit_area_drawings.json');
    }
};